export { type, TypeOptions } from './type';
